export default __webpack_public_path__ + "static/media/landscape1-MASK-base1.d0345aa5.png";